import { createFileRoute, Navigate } from '@tanstack/react-router';
import { pageTitle, usePageTitle } from '@/utils/pageTitle';
import { AccountTable } from '@/components/Pages/Accounts/AccountTable';
import { CreateEditAccountModal } from '@/components/Pages/Accounts/CreateEditAccountModal';
import { Box } from '@mui/joy';
import { useAuth } from '@/contexts/AuthContext';

export const Route = createFileRoute('/_protected/accounts/')({
  component: AccountsPage,
  head: () => pageTitle('Cuentas'),
});

function AccountsPage() {
  usePageTitle('Cuentas');
  const { hasClaim, isLoading } = useAuth();
  const canRead = hasClaim('ACCOUNTS_READ');
  const canWrite = hasClaim('ACCOUNTS_WRITE');

  if (!isLoading && !canRead) {
    return <Navigate to='/' />;
  }

  return (
    <Box>
      {canWrite && (
        <Box sx={{ display: 'flex', justifyContent: 'flex-end', mb: 3 }}>
          <CreateEditAccountModal />
        </Box>
      )}
      <AccountTable />
    </Box>
  );
}
